import { faBoxes } from '@fortawesome/free-solid-svg-icons';
import * as React from 'react';
import { FontAwesomeIcon } from './helpers/FontAwesomeIcon';

export const BoxesIcon = (props: { color?: string }) => {
  return (
    <FontAwesomeIcon icon={faBoxes} color={props.color || 'black'} />
  )
}
